import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Card, CardContent } from "../components/ui/card"
import { ArrowLeft, Search } from "lucide-react"

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
      <Card className="max-w-md w-full shadow-lg border-0">
        <CardContent className="text-center py-16">
          
          {/* 404 Number */}
          <h1 className="text-7xl font-bold text-primary mb-4">404</h1>

          {/* Message */}
          <h2 className="text-2xl font-semibold mb-3 font-heading">
            Page Not Found
          </h2>

          <p className="text-gray-600 mb-8">
            The page you're looking for doesn’t exist, was removed, or is temporarily unavailable.
          </p>

          {/* Buttons */}
          <div className="flex flex-col gap-4 items-center">
            
            <Button 
              asChild 
              className="w-full max-w-xs gap-2 font-heading"
            >
              <Link to="/">
                <ArrowLeft className="w-4 h-4" />
                Back to Home
              </Link>
            </Button>

            <Button 
              variant="outline" 
              asChild 
              className="w-full max-w-xs gap-2 font-heading"
            >
              <Link to="/search">
                <Search className="w-4 h-4" />
                Search Something Else
              </Link>
            </Button>

          </div>

        </CardContent>
      </Card>
    </div>
  )
}
